import React, {forwardRef} from 'react'
import {TwIcon} from '../containers'
import {TwButtonNew, TwText} from './containers'
import {ButtonNewProps} from './types'

export const ButtonNew = forwardRef(
  (
    {
      title,
      hint,
      icon,
      iconAfter,
      onClick,
      onMouseDown,
      size = 'sm',
      color = 'primary',
      forcedState,
      disabled,
      className,
      children,
      style,
      pending,
      fitWidth = false
    }: ButtonNewProps,
    ref
  ) => (
    <TwButtonNew
      ref={ref}
      role="button"
      content={hint}
      $color={color}
      $size={size}
      $disabled={disabled}
      $forcedState={forcedState}
      $fitWidth={fitWidth}
      className={className}
      style={style}
      onClick={!disabled ? onClick : undefined}
      onMouseDown={!disabled ? onMouseDown : undefined}
    >
      {pending && (
        <TwIcon icon="IconCustomWhiteLoader" className="animate-spin-slow" />
      )}
      {!pending && (
        <>
          {icon && <TwIcon icon={icon} viewBox="0 0 24 24" />}
          {children ?? (title && <TwText>{title}</TwText>)}
          {iconAfter && <TwIcon icon={iconAfter} viewBox="0 0 24 24" />}
        </>
      )}
    </TwButtonNew>
  )
)
